import Chip from "./Chip";

const components = {};

components.MuiChip = Chip;

export default components;
